import { useTranslation } from 'react-i18next';
import styles from './BundleUpchargePriceDeviationDrawerTable.module.css';
import classNames from 'classnames';
import { BundleUpchargePriceDeviationResponse } from '@/pages/Franchisee/Bundles/BundleUpcharges/components/PriceDeviation/bundleUpchargePriceDeviation.types';
import LockOutlined from '@mui/icons-material/LockOutlined';

export const BundleUpchargePriceDeviationDrawerTable = ({ data }: { data: BundleUpchargePriceDeviationResponse }) => {
  const { t } = useTranslation();
  const majorityExists = data.majorityPricePoint != null;
  return (
    <div>
      <table className={styles.table}>
        <tr>
          <th rowSpan={2} className={styles.productsHeader}>
            {t('priceDeviations.table.products')}
          </th>
          {majorityExists && (
            <th rowSpan={2} className={styles.majorityHeader}>
              {t('priceDeviations.table.majorityPricePoint')}
            </th>
          )}
          <th colSpan={2} className={styles.deviationsHeader}>
            {t('priceDeviations.table.priceDeviationsByStore')}
          </th>
        </tr>
        <tr>
          {data?.priceDeviations?.map((deviation) => (
            <td className={styles.storeHeader} key={deviation.storeNumber}>
              {deviation.storeNumber}
            </td>
          ))}
        </tr>
        <tr className={classNames({ [styles.evenRow]: 0 % 2 === 0 })} key={data.description}>
          <td>
            <div>
              <div className={styles.productName}>
                {data.isLock && (
                  <LockOutlined
                    className={styles.priceRangeInfo}
                    sx={{
                      width: '15px',
                      height: '15px',
                      color: '#cc2626',
                    }}
                  />
                )}
                {data.description}
              </div>
            </div>
          </td>
          {majorityExists && (
            <td
              className={classNames(styles.majorityPrice, {
                [styles.majorityEven]: 0 % 2 === 0,
                [styles.majorityOdd]: 0 % 2 !== 0,
              })}
            >
              {data.majorityPricePoint
                ? data.majorityPricePoint === '0.00'
                  ? 'None'
                  : `$${data.majorityPricePoint}`
                : '--'}
            </td>
          )}
          {data?.priceDeviations?.map((deviationPrice, count: number) => (
            <td
              className={classNames(styles.price, { [styles.firstPrice]: count === 0 })}
              key={deviationPrice.storeNumber}
            >
              {/* eslint-disable-next-line no-nested-ternary */}
              {deviationPrice.price ? (deviationPrice.price === '0.00' ? 'None' : `$${deviationPrice.price}`) : '--'}
            </td>
          ))}
        </tr>
      </table>
    </div>
  );
};
